import { render, staticRenderFns } from "./helpIndex.vue?vue&type=template&id=2d1475a6&scoped=true&"
import script from "./helpIndex.vue?vue&type=script&lang=js&"
export * from "./helpIndex.vue?vue&type=script&lang=js&"
import style0 from "./helpIndex.vue?vue&type=style&index=0&id=2d1475a6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d1475a6",
  null
  
)

export default component.exports